"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRelayerFeeEth = exports.etherscanApiUrls = exports.etherscanApiKeys = exports.rpcTimeoutSeconds = exports.rateLimitMaxRetries = exports.bondableChains = exports.config = exports.metadata = void 0;
const metadata_1 = require("./metadata");
Object.defineProperty(exports, "metadata", { enumerable: true, get: function () { return metadata_1.metadata; } });
const goerli = __importStar(require("./goerli"));
const mainnet = __importStar(require("./mainnet"));
const addresses = {
    mainnet: mainnet.addresses,
    goerli: goerli.addresses
};
const chains = {
    mainnet: mainnet.chains,
    goerli: goerli.chains
};
const bonders = {
    mainnet: mainnet.bonders,
    goerli: goerli.bonders
};
const bonderFeeBps = {
    mainnet: mainnet.bonderFeeBps,
    goerli: goerli.bonderFeeBps
};
const destinationFeeGasPriceMultiplier = {
    mainnet: mainnet.destinationFeeGasPriceMultiplier,
    goerli: goerli.destinationFeeGasPriceMultiplier
};
const relayerFeeEnabled = {
    mainnet: mainnet.relayerFeeEnabled,
    goerli: goerli.relayerFeeEnabled
};
const proxyEnabled = {
    mainnet: mainnet.proxyEnabled,
    goerli: goerli.proxyEnabled
};
const bridgeDeprecated = {
    mainnet: mainnet.bridgeDeprecated,
    goerli: goerli.bridgeDeprecated
};
const config = {
    addresses,
    chains,
    bonders,
    bonderFeeBps,
    destinationFeeGasPriceMultiplier,
    relayerFeeEnabled,
    proxyEnabled,
    bridgeDeprecated
};
exports.config = config;
exports.bondableChains = ['optimism', 'arbitrum', 'nova', 'zksync', 'linea', 'scrollzk', 'base', 'polygonzk'];
exports.rateLimitMaxRetries = 3;
exports.rpcTimeoutSeconds = 60;
exports.etherscanApiKeys = {
    ethereum: (_a = process.env.ETHERSCAN_ETHEREUM_API_KEY) !== null && _a !== void 0 ? _a : '',
    polygon: (_b = process.env.ETHERSCAN_POLYGON_API_KEY) !== null && _b !== void 0 ? _b : '',
    optimism: (_c = process.env.ETHERSCAN_OPTIMISM_API_KEY) !== null && _c !== void 0 ? _c : '',
    arbitrum: (_d = process.env.ETHERSCAN_ARBITRUM_API_KEY) !== null && _d !== void 0 ? _d : '',
    gnosis: (_e = process.env.ETHERSCAN_GNOSIS_API_KEY) !== null && _e !== void 0 ? _e : '',
    nova: (_f = process.env.ETHERSCAN_NOVA_API_KEY) !== null && _f !== void 0 ? _f : '',
    base: (_g = process.env.ETHERSCAN_BASE_API_KEY) !== null && _g !== void 0 ? _g : ''
};
exports.etherscanApiUrls = {
    ethereum: 'https://api.etherscan.io',
    polygon: 'https://api.polygonscan.com',
    optimism: 'https://api-optimistic.etherscan.io',
    arbitrum: 'https://api.arbiscan.io',
    gnosis: 'https://api.gnosisscan.io',
    nova: 'https://api-nova.arbiscan.io',
    base: 'https://api.basescan.org'
};
exports.defaultRelayerFeeEth = '0.01';
